import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './layouts/Layout';
import HomePage from './pages/HomePage';
import DiscoverPage from './pages/DiscoverPage';
import ForumPage from './pages/ForumPage';
import AboutPage from './pages/AboutPage';
import ScrollToTop from './utils/ScrollToTop'; // --- IMPORT THE NEW COMPONENT ---

function App() {
  return (
    <BrowserRouter>
      {/* --- ADD THE COMPONENT HERE --- */}
      <ScrollToTop /> 
      
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/forum" element={<ForumPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;